import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { VerifyFileUploadRPC } from "./verifyFileUploadRPC";

export class VerifyFileUploadRPCClientImpl extends VerifyFileUploadRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: VerifyFileUploadRPC.Request): Promise<LeoRPCResult<VerifyFileUploadRPC.Response, VerifyFileUploadRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "file-service/VerifyFileUpload",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      VerifyFileUploadRPC.ResponseDTO,
      VerifyFileUploadRPC.Errors.ErrorsDTO,
      VerifyFileUploadRPC.Response,
      VerifyFileUploadRPC.Errors.Errors
    >(
      response,
      "file-service/VerifyFileUpload",
      VerifyFileUploadRPC.Response.fromDTO,
      VerifyFileUploadRPC.Errors.fromDTO
    );
  }
}
